import React from 'react'
import { Link } from 'react-router-dom'
import Icons from "../../myIcon/Icons";

export default function HowWeWork({ data, handleShow }) {
   return (
      <>
         <section className='howwework-section'>
            <div className='container'>
               <div className='row justify-content-center'>
                  <div className='col-lg-6 text-center'>
                     <h4 className='heading'>{data.heading}</h4>
                     <p>{data.description} </p>
                  </div>
               </div>
               {
                  data.process.map((item, index) => (

                     <div className={`row align-items-center workspace ${index === data.process.length - 1 ? "last-workspace" : ""}`} key={index}>
                        <div className={`col-lg-6 col-md-6 order-1 ${index % 2 === 0 ? "order-md-1" : "order-md-2"}`}>
                           <div className={`wework-content ${index === 1 || index === 3 ? "content-space" : ""}`}>
                              <span>{item.number}</span>
                              <h5>{item.title}</h5>
                              <p>{item.description}</p>
                           </div>
                        </div>

                        <div
                           className={`col-lg-6 col-md-6 order-2 ${index % 2 === 0 ? "order-md-2" : " order-md-1"}`}>
                           <div className='wework-img'>
                              <img src={item.image} alt={item.title} className='img-responsive' />
                           </div>
                        </div>
                     </div>
                  ))
               }

               <div className='work-btns'>
                  <Link onClick={handleShow} className="default-btn">
                     Get A Quote
                     <Icons name="Longarrow_right" />
                  </Link>
                  <Link onClick={handleShow} className="default-btn colored-btn">
                     Call Now
                     <Icons name="Longarrow_right" />
                  </Link>
               </div>
            </div>
         </section>
      </>
   )
}